<p-dialog
  [style]="{ width: '640px', minWidth: '640px', minHeight: '256px'}"
  header="User Preferences"
  [closable]="false"
  [visible]="true"
  [focusOnShow]="true"
  appendTo="body">

  <div *ngIf="!(settingsPresentation$ | async)">Loading...</div>
  <div class="container" style="width:100%;" *ngIf="settingsPresentation$ | async as sp">

    <div class="row">
      <label for="{{sp.SendEmailOnFormAssignment.controlId}}"
             class="col-8 sentence">{{ sp.SendEmailOnFormAssignment.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.SendEmailOnFormAssignment.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.SendEmailOnFormAssignment.value.current"
          [options]="sp.SendEmailOnFormAssignment.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <mojo-periodic-email-settings
      #periodicEmailSettings
      [displayMode]="DM.UserPreferences"
      [settingsTuple]="sp.PeriodicEmailSettingsTuple"
      (settingsChanged)="periodicEmailSettingsChanged($event)"
      style="width:100%;"></mojo-periodic-email-settings>

    <div class="row">
      <label for="{{sp.DisplayNonCurrentManagers.controlId}}"
             class="col-8 sentence">{{ sp.DisplayNonCurrentManagers.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.DisplayNonCurrentManagers.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.DisplayNonCurrentManagers.value.current"
          [options]="sp.DisplayNonCurrentManagers.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <div class="row">
      <label for="{{sp.SkipListerPage.controlId}}"
             class="col-8 sentence">{{ sp.SkipListerPage.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown id="{{sp.SkipListerPage.controlId}}"
                    hideDropdownOnScroll
                    [(ngModel)]="sp.SkipListerPage.value.current"
                    [options]="sp.SkipListerPage.options"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    [style]="{'width': '100%'}"
                    (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <div class="row">
      <label for="{{sp.DisplayObsoleteUnits.controlId}}"
             class="col-8 sentence">{{ sp.DisplayObsoleteUnits.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.DisplayObsoleteUnits.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.DisplayObsoleteUnits.value.current"
          [options]="sp.DisplayObsoleteUnits.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <div class="row">
      <label for="{{sp.FormCompletionNavigation.controlId}}"
             class="col-8 sentence">{{ sp.FormCompletionNavigation.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.FormCompletionNavigation.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.FormCompletionNavigation.value.current"
          [options]="sp.FormCompletionNavigation.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <div class="row">
      <label for="{{sp.DisplayNonCurrentLeasesAndTenants.controlId}}"
             class="col-8 sentence">{{ sp.DisplayNonCurrentLeasesAndTenants.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.DisplayNonCurrentLeasesAndTenants.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.DisplayNonCurrentLeasesAndTenants.value.current"
          [options]="sp.DisplayNonCurrentLeasesAndTenants.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

    <div class="row">
      <label for="{{sp.DisplayNonCurrentHeadLeasesAndLandlords.controlId}}"
             class="col-8 sentence">{{ sp.DisplayNonCurrentHeadLeasesAndLandlords.controlLabelText }}</label>
      <div class="col-4" style="display:inline-block;">
        <p-dropdown
          id="{{sp.DisplayNonCurrentHeadLeasesAndLandlords.controlId}}"
          hideDropdownOnScroll
          [(ngModel)]="sp.DisplayNonCurrentHeadLeasesAndLandlords.value.current"
          [options]="sp.DisplayNonCurrentHeadLeasesAndLandlords.options"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [style]="{'width': '100%'}"
          (onChange)="onDropDownChanged($event)"></p-dropdown>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix admin-form">
      <button type="button" pButton icon="fa-fw fa fa-check" [disabled]="!saveButtonEnabled" (click)="save()"
              label="Save"></button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>

</p-dialog>
